<template>
  <v-container fluid>
    <tooltip/>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Planning Absences</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-alert border="top" class="my-4" color="#F44336" dark dense v-if="errors.length>0"
                 v-model="alert">
          <h4 class="mt-2">{{ errors.length }}{{ " Erreur" | pluralize(errors.length) }}
            sur {{ excelData.length }} {{ "enregistrement"|pluralize(excelData.length) }}.
            Merci de corriger et de ne réimporter que les enregistrements ci-dessous rejetés, pour éviter
            tout doublon
          </h4>
          <v-row align="center">
            <v-col class="grow">
              <div :key="index" v-for="(error,index) in errors">
                <h5>
                  <v-icon>mdi-alert-circle</v-icon>
                  {{ "Matricule (" + error.datas.userId + ") -> " + error.message }}
                </h5>
              </div>
            </v-col>
            <v-col class="shrink">
              <v-btn :elevation="1" @click="closeAlert" fab small
                     style="position:absolute;top:18px;right:12px">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
        <modal :adaptive=true
               :clickToClose="false"
               :draggable=false
               :resizable=false
               height="auto"
               name="modal-fade-infoHS">
          <v-card>
            <v-container>
              <v-card-text>
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true">
                  <v-row class="justify-center align-center">
                    <h2 style="color:#01579B">La liste des Heures Sup pour l'absence choisie :</h2>
                    <br>
                    <br>
                    <h4 style="color:dimgrey">
                      <ul id="example-1">
                        <li :key="item" v-for="item in listHS2Show">
                          {{ item }}
                        </li>
                      </ul>
                    </h4>
                  </v-row>
                  <v-row>
                    <v-spacer></v-spacer>
                    <v-btn @click="fermer"
                           class="v-btnInfoHS"
                           color="#01579B"
                           depressed
                           outlined
                           width="120">Quitter
                    </v-btn>
                  </v-row>
                </template>
              </v-card-text>
            </v-container>
          </v-card>
        </modal>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-select :disabled="disableMainBtn" :items="selectDates" @change="depthDate" dense filled
                        full-width
                        hide-details="true"
                        item-text="name" item-value="value" return-object solo
                        style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexportModele" block
                     class="custom-btn white--text"
                     color="#03A9F4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-download-circle-outline</v-icon>
                <span>Export modèle</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export absences</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog max-width="600px" persistent v-model="dialog">
                <template @mouseleave.native="hover = false" @mouseover.native="hover = true"
                          v-slot:activator="{ on }">
                  <v-btn :disabled="disableMainBtn" @click="initdatetime()" block
                         class="custom-btn white--text"
                         color="#009688"
                         height="45px"
                         large
                         v-on="on">
                    <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                    <span>Nouvelle absence</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar
                      color="#01579B"
                      dark
                      flat>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="close"
                        dark
                        fab
                        small>
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-tabs :grow=true background-color="#01579B" color="#f5f5f5" dark="" right
                          v-model="tab">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1"> Via un formulaire</v-tab>
                    <v-tab href="#tab-2"> Via un fichier excel</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-1">
                      <v-card-text>
                        <v-container>
                          <v-row class="justify-center align-center">
                            <v-col md="6" sm="6">
                              <v-text-field :id="dynamicID()"
                                            @change="activateIdHS"
                                            class="centered-input align-center"
                                            color="#01579B"
                                            label="Matricule agent"
                                            prepend-inner-icon="mdi-human-male"
                                            v-model="editedItem.userId">
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col md="9" sm="6">
                              <v-select :items="absencetypes"
                                        @change="activateIdHS"
                                        class="centered-input align-center text-center"
                                        item-text="type"
                                        item-value="type"
                                        label="Raison"
                                        prepend-inner-icon="mdi-apple-keyboard-option"
                                        v-model="editedItem.reasonAbsence">
                              </v-select>
                              <template v-slot:selection="{ item }">
                                                              <span class="d-flex justify-center" style="width: 100%;">
                                                                {{ item }}
                                                              </span>
                              </template>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="6" sm="6">
                              <v-menu
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  min-width="290px"
                                  offset-y
                                  transition="scale-transition"
                                  v-model="menu1"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Date début"
                                                persistent-hint
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormatted1"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="menu1= false"
                                    locale="fr-FR"
                                    v-model="editedItem.startDate"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="6" sm="6">
                              <v-menu
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  min-width="290px"
                                  offset-y
                                  transition="scale-transition"
                                  v-model="menu2"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field :id="dynamicID()"
                                                class="centered-input align-center"
                                                label="Date fin Shift"
                                                persistent-hint
                                                prepend-inner-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-model="computedDateFormatted2"
                                                v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                    @input="menu2= false"
                                    locale="fr-FR"
                                    v-model="editedItem.endDate"
                                ></v-date-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="12" sm="12">
                              <v-text-field :id="dynamicID()"
                                            class="centered-input align-center"
                                            color="#01579B"
                                            label="Observations"
                                            prepend-inner-icon="mdi-comment-edit-outline"
                                            rows="1"
                                            textarea
                                            v-model="editedItem.absenceObservations"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="justify-center align-center">
                            <v-col>
                              <v-dialog max-width="1400px" persistent
                                        transition="dialog-top-transition"
                                        v-model="dialogHS">
                                <template @mouseleave.native="hover = false"
                                          @mouseover.native="hover = true"
                                          v-slot:activator="{ on }">
                                  <v-row>
                                    <v-col v-if="isMobile===false">
                                      <v-spacer></v-spacer>
                                    </v-col>
                                    <v-col>
                                      <v-btn @click="initHS()"
                                             color="#01579B"
                                             depressed
                                             height="45px"
                                             large
                                             outlined v-if="!disabledIdHS"
                                             v-on="on">
                                        <v-icon class="mr-1">
                                          mdi-clipboard-list-outline
                                        </v-icon>
                                        <span>Choix Heures Sup</span>
                                      </v-btn>
                                    </v-col>
                                    <v-col v-if="isMobile===false">
                                      <v-spacer></v-spacer>
                                    </v-col>
                                  </v-row>
                                  <v-row class="justify-center align-center">
                                    {{ editedItem.idHS }}
                                  </v-row>
                                </template>
                                <v-card>
                                  <v-toolbar dense style="background:#F5F5F5">
                                    <v-spacer></v-spacer>
                                    <v-toolbar-title class="flex text-center" dark
                                                     dense
                                                     style="color:#01579B;font-weight:bold;font-size: 18pt">
                                      Faites votre sélection puis validez en
                                      cliquant sur la croix.
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        @click="closeHS"
                                        dark
                                        fab
                                        small>
                                      <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                  </v-toolbar>
                                  <v-dialog fullscreen style="z-index:1000"
                                            v-model="loading">
                                    <v-container fill-height fluid
                                                 style="background-color: rgba(200, 200, 200, 0.5);">
                                      <v-layout align-center="true" justify-center="true">
                                        <v-progress-circular
                                            :on-cancel="onCancel"
                                            :size="70"
                                            color="#009688"
                                            indeterminate>
                                        </v-progress-circular>
                                      </v-layout>
                                    </v-container>
                                  </v-dialog>
                                  <v-card-text>
                                  </v-card-text>
                                  <v-card-text>
                                    <v-alert :color=AlertColorHS(typeHS)
                                             :dismissible=true
                                             :value=true
                                             @input="dismissible_close_HS"
                                             border="top"
                                             class="pre-formatted multi-line"
                                             colored-border
                                             elevation="2"
                                             icon="check_circle"
                                             v-if="typeHS">
                                      {{ textHS }}
                                    </v-alert>
                                    <v-card class="mt-4" elevation="6"
                                            style="z-index: 999">
                                      <hot-table :settings="hotSettingsHS"
                                                 ref="hotTableHS"></hot-table>
                                    </v-card>
                                  </v-card-text>
                                </v-card>
                              </v-dialog>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!FormIsValid && !loading"
                               @click="checkIdHeuresSupExist"
                               class="white--text"
                               color="#01579B" depressed>Créer Absence
                        </v-btn>
                      </v-card-actions>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                      <v-card v-if="!file">
                        <v-container v-if="loading">
                          <div class="text-center">
                            <v-progress-circular color="green" indeterminate>
                            </v-progress-circular>
                          </div>
                        </v-container>
                        <v-btn :disabled="!fileBtn" @click="onPickFile" block
                               class="mr-2 mb-2"
                               large style="color:#01579B; background-color:#F5F5F5"
                               v-if="!loading">
                          <v-icon>mdi-paperclip</v-icon>
                          Importer ICI ou Glisser/Copier le fichier Excel ci-dessous
                        </v-btn>
                        <input @change="onFilePicked($event)" accept="xlsx/*" id="upload"
                               ref="fileInput"
                               style="display:none" type="file"/>
                      </v-card>
                      <v-card>
                        <div class="text-center">
                          <v-card-text>
                            <v-chip color="white" disabled label small
                                    v-if="file">
                              {{ file.name }} ({{ file.size | kb }} kb)
                            </v-chip>
                            <v-btn @click="removeFile(file)"
                                   title="Supprimer"
                                   v-if="file">
                              <v-icon style="color:indianred;">
                                mdi-delete-circle-outline
                              </v-icon>
                            </v-btn>
                            <template>
                              <div ref="others">
                                <div :class="['downbox', drag_over ? 'over' : '']"
                                     @dragenter="dragEnter"
                                     @dragleave="dragLeave"
                                     @dragover.prevent
                                     @drop.prevent="addFile"
                                     @ondragover="dragOver"
                                     v-cloak>
                                  <v-btn
                                      color="primary"
                                      height="100px"
                                      outlined
                                      v-if="!file"
                                      width="100%"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                              <v-spacer></v-spacer>
                              <v-btn :disabled="loading" :loading="loading"
                                     @click.prevent="importFileToHandsonTable"
                                     color="#009688" dark
                                     depressed
                                     fab
                                     v-if="file">
                                <v-icon>mdi-cloud-upload</v-icon>
                                <span class="custom-loader" slot="loader">
                                                                        <v-icon color="white" light>cached</v-icon>
                                                                        </span>
                              </v-btn>
                            </template>
                          </v-card-text>
                        </div>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";
import Vue from "vue";
import 'vue-js-modal/dist/styles.css'

//v-popover:tooltip="'Vous pouvez aussi poser plusieurs \'Id Heures Sup\' séparés par une virgule !'">

function customDropDownRender(instance, td, row, col, prop, value, cellProperties) {
  Handsontable.renderers.AutocompleteRenderer.apply(this, arguments);
  cellProperties.data = 'options';
  cellProperties.type = 'dropdown';

  if (col === 9) {
    cellProperties.source = JSON.parse(sessionStorage.getItem("RaisonsAbsences"))
  }
}

function cellHSRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);

  if (column === 13) {
    td.className = "colHS";
  }
}

Vue.filter('kb', val => {
  return Math.floor(val / 1024);
});

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "absences",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      listHS2Show: [],
      disabledIdHS: true,
      disableMainBtn: false,
      searchName: "",
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      menu1: null,
      menu2: null,
      type: null,
      typeHS: null,
      elapse: null,
      elapseHS: null,
      loading: false,
      toObject: [],
      toObjectHS: [],
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      editedItem: {
        userId: "",
        reasonAbsence: "",
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
        absenceObservations: "",
        idHS: "",
        onGoing: ""
      },
      tab: null,
      dialog: false,
      dialogHS: false,
      alert: false,
      alertHS: false,
      fullPage: false,
      text: "",
      textHS: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      errorsHS: [],
      excelData: [],
      brigadetypes: [],
      absencetypes: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: false,
        afterOnCellMouseUp: this.afterOnCellMouseUpMe,
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0, 8],
          indicators: false
        },
        colHeaders: [
          "Id", "Matricule", "Nom", "Prénom", "Brigade", "Date début", "Date fin", "EnCours",
          "Plannifiée", "Raison absence", "Nbre jours total", "Nbre jours restant",
          "Observations", "Heures Sup", "Date création", "Matricule créateur"
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {title: "Matricule", width: "150px"},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénom", width: "200px", readOnly: true},
          {title: "Brigade", width: "160px", readOnly: true},
          {
            title: "Date début",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {
            title: "Date fin",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {title: "EnCours", width: "120px", type: "checkbox", readOnly: true},
          {title: "Plannifiée", width: "120px", type: "checkbox", readOnly: true},
          {
            title: "Raison absence",
            width: "300px",
            type: "dropdown",
            renderer: customDropDownRender,
            allowInvalid: false,
            strict: true
          },
          {title: "Nbre jours total", width: "160px", readOnly: true},
          {title: "Nbre jours restant", width: "160px", readOnly: true},
          {title: "Observations", width: "180px"},
          {title: "Heures Sup", width: "180px", readOnly: true},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px", readOnly: true}
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};

          if (col === 13) {
            if ((this.instance.getSourceDataAtCell(row, 13) !== "") && (this.instance.getSourceDataAtCell(row, 13) !== null)) {
              cellProperties.renderer = cellHSRenderer;
            }
          }

          return cellProperties;
        }
      },
      hotSettingsHS: {
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        afterChange: this.afterChangeMeHS,
        afterFilter: this.afterFilterHS,
        afterLoadData: this.afterLoadDataHS,
        stretch: "all",
        manualColumnResize: true,
        comment: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [1, 5, 6, 7, 12, 13, 14],
          indicators: false
        },

        colHeaders:
            ["Sélection", "Id Heures Sup", "Matricule", "Nom", "Prénom", "Brigade", "Jour Shift rattaché", "Nom Shift rattaché", "Date début Heures Sup",
              "Date fin Heures Sup", "Observations", "Durée Heures Sup", "Compensation", "Date création", "Matricule créateur"],
        columns: [
          {title: "Sélection", width: "80px", type: "checkbox"},
          {title: "Id Heures Sup", width: "150px", readOnly: true},
          {title: "Matricule", width: "80px", readOnly: true},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénom", width: "200px", readOnly: true},
          {title: "Brigade", width: "160px", readOnly: true},
          {title: "Jour Shift rattaché", width: "180px", readOnly: true},
          {title: "Nom Shift rattaché", width: "200px", readOnly: true},
          {title: "Date début Heures Sup", width: "160px", readOnly: true},
          {title: "Date Fin Heures Sup", width: "160px", readOnly: true},
          {title: "Observations", width: "250px", readOnly: true},
          {title: "Durée Heures Sup", width: "130px", readOnly: true},
          {title: "Compensation", width: "150px", type: "checkbox", readOnly: true},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px", readOnly: true}
        ],
      }
    }
  },
  created() {
    this.getData(this.depthVal)
    this.loadAbsencesTypes()
  },
  computed: {
    FormIsValid() {
      return (
          this.editedItem.userId !== "" &&
          this.editedItem.reasonAbsence !== "" &&
          this.editedItem.startDate !== "" &&
          this.editedItem.endDate !== "" &&
          this.editedItem.absenceObservations !== ""
      );
    },

    computedDateFormatted1() {
      return this.formatDate(this.editedItem.startDate)
    },

    computedDateFormatted2() {
      return this.formatDate(this.editedItem.endDate)
    },
  },

  methods: {
    activateIdHS() {
      let absenceReason = this.editedItem.reasonAbsence
      let S1 = "Repos compensateur"

      let S1Result = absenceReason.toLowerCase().localeCompare(S1.toLowerCase())

      if (this.isEmpty(this.editedItem.userId) || this.isEmpty(this.editedItem.startDate) || this.isEmpty(this.editedItem.endDate)) {
        this.disabledIdHS = true;
        return;
      }

      this.disabledIdHS = (S1Result !== 0);
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    initdatetime() {
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.editedItem.startDate = this.editedItem.endDate = new Date().toISOString().substr(0, 10);
      this.editedItem.reasonAbsence = "";
      this.editedItem.userId = "";
      this.editedItem.absenceObservations = "";
      this.editedItem.idHS = "";
    },
    initHS() {
      this.getDataHS()
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDateString(date) {
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData(this.depthVal)
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    initEditedItem() {
      this.userId = ""
      this.reasonAbsence = ""
      this.startDate = new Date().toISOString().substr(0, 10)
      this.endDate = new Date().toISOString().substr(0, 10)
      this.absenceObservations = ""
      this.idHS = ""
      this.onGoing = ""
    },
    show() {
      this.$modal.show('modal-fade-infoHS');
    },
    hide() {
      this.$modal.hide('modal-fade-infoHS');
    },
    getData(valeur) {
      this.loading = true
      valeur = this.depthVal.value
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/absencesbydatedepth/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId"), {timeout: 360000}
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                this.convertDate(item["startDate"]),
                this.convertDate(item["endDate"]),
                item["onGoing"],
                item["plannifiee"],
                item["reasonAbsence"],
                item["totalDaysNumber"],
                item["totalDaysRemaining"],
                item["absenceObservations"],
                !this.isEmpty(item["idHS"]) ? "Heures Sup liées" : "",
                this.datefull(item["creationDate"]),
                item["originUser"]
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    fermer() {
      this.hide();
    },
    afterOnCellMouseUpMe: function (event, coords) {
      if (coords.col === 13 && coords.row >= 0) {

        let toObjectTmp = Array.from(this.toObject)
        toObjectTmp.shift()
        if ((toObjectTmp[coords.row][13] !== "") && (toObjectTmp[coords.row][13] !== null)) {
          this.getListHS2Show(toObjectTmp[coords.row][0])
        }
      }
    },
    getDataHS() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/heuressupabsence/` + this.editedItem.userId + "/" + sessionStorage.getItem("userId"), {timeout: 360000}
          )
          .then(response => {
            let tabArray = []

            if (response.data.status !== 200) {
              //this.dialogHS = false
              this.color = "#F44336"
              this.alertHS = true
              this.textHS = response.data.message;
              this.showAlertHS('warning')

              this.$refs.hotTableHS.hotInstance.loadData([])
              return
            }

            let newObj = response.data.datas;

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                (!this.isEmpty(this.editedItem.idHS)) ? (item["checkHS"] = this.isIdHSChecked(item["id"], this.editedItem.idHS)) : item["checkHS"],
                item["id"],
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                (this.isEmpty("dateShift") || (item["dateShift"] === null)) ? "" : this.formatDate(item["dateShift"]),
                item["nameShift"],
                this.formatDate(item["startDayHeuresSup"]) + " " + item["startHourHeuresSup"],
                this.formatDate(item["endDayHeuresSup"]) + " " + item["endHourHeuresSup"],
                item["observations"],
                item["heuresSupDuration"],
                item["compensation"],
                this.datefull(item["creationDate"]),
                item["originUser"]
              ])
            })

            this.$refs.hotTableHS.hotInstance.loadData(tabArray)
            this.toObjectHS = this.$refs.hotTableHS.hotInstance.getData()
          })
          .catch(() => {
          });
    },
    getListHS2Show(idAbsence) {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/heuressupidabsence/` + idAbsence + "/" + sessionStorage.getItem("userId"), {timeout: 360000}
          )
          .then(response => {
            let newObj = response.data.datas;

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            this.listHS2Show = [];
            let str = "";
            let strTmp = "";

            newObj.forEach((item) => {
              strTmp = this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase()
              str = item["userId"] + " - " + strTmp
              strTmp = this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true)
              str = str + " - " + strTmp
              strTmp = this.formatDate(item["startDayHeuresSup"]) + " " + item["startHourHeuresSup"]
              str = str + " - " + strTmp
              strTmp = this.formatDate(item["endDayHeuresSup"]) + " " + item["endHourHeuresSup"]
              str = str + " - " + strTmp
              this.listHS2Show.push(str)
            })

            this.loading = false
            this.show();
          })
          .catch(() => {
            this.loading = false
          });
    },
    isIdHSChecked(idHS, listIdHS) {
      if (this.isEmpty(listIdHS))
        return false;

      let bRresult = false;
      let datas
      if (listIdHS.search(",") !== -1) {
        datas = listIdHS.split(',')
        if (datas.length === 0)
          return false;

        datas.forEach((item) => {
          if (idHS === item.trim())
            bRresult = true;
        })
      } else {
        if (idHS === listIdHS)
          bRresult = true;
      }

      return bRresult;
    },
    loadAbsencesTypes() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/absencetypes/` +
              sessionStorage.getItem("userId"), {timeout: 360000}
          )
          .then(response => {
            sessionStorage.setItem("RaisonsAbsences", null)
            let datas = response.data.datas;
            this.absencetypes = datas;
            datas.forEach(item => {
              this.arrayAbs.push(item.type)
            })
            sessionStorage.setItem("RaisonsAbsences", JSON.stringify(this.arrayAbs))
          })
          .catch(() => {
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.disabledIdHS = true;
      this.dialog = false;
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
      this.initEditedItem();
    },
    afterLoadDataHS() {
      this.toObjectHS = [this.$refs.hotTableHS.hotInstance.getData()]
    },
    afterFilterHS() {
      this.toObjectHS = [this.$refs.hotTableHS.hotInstance.getData()]
    },
    closeHS() {
      this.editedItem.idHS = ""
      this.toObjectHS.forEach((item) => {
        if (item[0] === true) {
          this.editedItem.idHS = this.isEmpty(this.editedItem.idHS) ? (item[1] + "") : this.editedItem.idHS + ", " + item[1]
        }
      })

      this.$refs.hotTableHS.hotInstance.loadData([])
      this.dialogHS = false;
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    AlertColorHS(typeHS) {
      return typeHS === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    showAlertHS(typeHS) {
      this.typeHS = typeHS

      let timer = this.showAlertHS.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlertHS.timer = setTimeout(() => {
        this.typeHS = null
      }, 20000)

      this.elapseHS = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapseHS === 3) {
          this.elapseHS = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapseHS++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    dismissible_close_HS() {
      this.elapseHS = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.typeHS = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    closeAlertHS() {
      this.alertHS = false
      this.textHS = ""
      this.errorsHS = []
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    getDay(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}`
    },
    getMonth(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}`
    },
    getYear(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}`
    },
    getHour(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${hh}`
    },
    getMin(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${mm}`
    },
    getSec(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${ss}`
    },
    afterChangeMe(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        this.loading = true
        let message = {
          title: 'Fenêtre de confirmation',
          body: 'Confirmez la modification de l\'absence.'
        };

        this.$dialog
            .confirm(message)
            .then(dialog => {
              let obj = {}
              let newObj = {}
              obj = this.$refs.hotTable.hotInstance.getData()[changes[0][0]]

              let sdate = moment(obj[5], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")
              let edate = moment(obj[6], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss")

              if ((sdate === "Invalid date") || (edate === "Invalid date")) {
                this.text = "Date & Heure invalide -> Ligne " + (changes[0][0] + 1) +
                    ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

                this.showAlert('warning')
                this.loading = false
                dialog.close();
                this.refresh()
                return;
              }

              if ((changes[0][1] === 5) || (changes[0][1] === 6)) {
                if (!this.isEmpty(obj[13])) {
                  this.text = "Les dates ne peuvent pas être changées car il y a des Heures Sup qui y sont rattachées.\nCependant, vous pouvez supprimez l'absence et la recréer."
                  this.showAlert('warning')
                  this.loading = false
                  dialog.close();
                  this.refresh()
                  return;
                }
              }

              if (obj[8] === true) {
                newObj = {
                  "id": obj[0],
                  "userId": obj[1],
                  "startDate": sdate,
                  "endDate": edate,
                  "reasonAbsence": obj[9],
                  "absenceObservations": obj[12],
                  "idHS": obj[13]
                }

                apiClient
                    .post(
                        `${this.$store.getters.user.baseUrl}/account/absence/` +
                        sessionStorage.getItem("userId"),
                        newObj
                    )
                    .then(res => {
                      dialog.close();
                      this.loading = false
                      if (res.data.status === 200) {
                        this.color = "#009688"
                        this.text = res.data.message;
                        this.showAlert('info')
                        this.depthDate()
                      } else {
                        this.color = "#F44336"
                        this.alert = true
                        this.text = res.data.message;
                        this.dialog = false;
                        this.initEditedItem();

                        let myData = this.$refs.hotTable.hotInstance.getData()
                        myData[changes[0][0]][changes[0][1]] = changes[0][2]
                        myData[changes[0][0]][0] = res.data.datas.id
                        this.$refs.hotTable.hotInstance.loadData(myData)
                        this.showAlert('warning')
                      }
                    })
                    .catch((err) => {
                      dialog.close();
                      let myData = this.$refs.hotTable.hotInstance.getData()
                      myData[changes[0][0]][changes[0][1]] = changes[0][2]
                      this.$refs.hotTable.hotInstance.loadData(myData)

                      this.alert = true
                      this.color = "#F44336"
                      this.text = err.data.message;
                      this.loading = false
                      this.showAlert('warning')
                    });
              } else {
                if (changes[0][1] === 9 || changes[0][1] === 12) {
                  const dataToSave = {
                    userId: obj[1],
                    startDate: moment(obj[5], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss"),
                    endDate: moment(obj[6], "DD-MM-YYYY").format("YYYY-MM-DD HH:mm:ss"),
                    reasonAbsence: obj[9],
                    absenceObservations: obj[12],
                    idHS: obj[13],
                  };
                  apiClient
                      .post(`${this.$store.getters.user.baseUrl}/account/absence/` + sessionStorage.getItem("userId"),
                          dataToSave
                      )
                      .then(res => {
                        dialog.close();
                        this.loading = false
                        if (res.data.status === 200) {
                          this.color = "#009688"
                          this.text = res.data.message
                          this.dialog = false;

                          this.showAlert('info')
                          this.depthDate();
                        } else {
                          this.alert = true
                          this.color = "#F44336"
                          this.alert = true
                          this.text = res.data.message;
                          this.dialog = false;
                          this.initEditedItem();

                          let myData = this.$refs.hotTable.hotInstance.getData()
                          myData[changes[0][0]][changes[0][1]] = changes[0][2]
                          this.$refs.hotTable.hotInstance.loadData(myData)
                          this.showAlert('warning')
                        }
                      })
                      .catch(error => {
                        dialog.close();
                        let myData = this.$refs.hotTable.hotInstance.getData()
                        myData[changes[0][0]][changes[0][1]] = changes[0][2]
                        this.$refs.hotTable.hotInstance.loadData(myData)

                        this.alert = true
                        this.text = error;
                        this.dialog = false;
                        this.loading = false
                        this.color = "#F44336"
                        this.showAlert('warning')
                      });
                } else {
                  dialog.close();
                  this.alert = true
                  this.color = "#F44336"
                  this.text = "Ce champ n'est modifiable qu'à partir du menu 'Planning Présences'.";
                  this.loading = false

                  let myData = this.$refs.hotTable.hotInstance.getData()
                  myData[changes[0][0]][changes[0][1]] = changes[0][2]
                  this.$refs.hotTable.hotInstance.loadData(myData)
                  this.showAlert('warning')
                }
              }
            })
            .catch(() => {
              let myData = this.$refs.hotTable.hotInstance.getData()
              myData[changes[0][0]][changes[0][1]] = changes[0][2]
              this.$refs.hotTable.hotInstance.loadData(myData)
              this.loading = false
            });
      }
    },
    afterChangeMeHS(changes, source) {
      if (changes !== null && source === "edit" && (changes[0][2] !== changes[0][3])) {
        let obj = {}
        obj = this.$refs.hotTableHS.hotInstance.getData()[changes[0][0]]
        this.toObjectHS[changes[0][0]][0] = obj[0] === true;
      }
    },
    beforeRemoveRowMe(index, amount) {
      let rowId = this.$refs.hotTable.hotInstance.getData()[index]
      // Trigger an Alert dialog
      // Trigger a confirmation dialog
      let message = {
        title: 'Fenêtre de confirmation',
        body: 'Confirmez la suppression de l absence.'
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true
            //this.loading = true
            let choice = (rowId[8] === true) ? "absences" : "presences"

            apiClient
                .delete(
                    `${this.$store.getters.user.baseUrl}/account/` + choice + `/` + rowId[0] + "/" + sessionStorage.getItem("userId")
                )
                .then(res => {
                  dialog.close();
                  this.loading = false
                  if (res.data.status === 200) {
                    this.color = "#009688"
                    this.text = res.data.message;
                    this.showAlert('info')
                  } else {
                    this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", false);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 15, "readOnly", false);

                    this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

                    this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", true);
                    this.$refs.hotTable.hotInstance.setCellMeta(index, 15, "readOnly", true);

                    this.color = "#F44336"
                    this.alert = true
                    this.text = res.data.message;
                    this.dialog = false;
                    this.showAlert('warning')
                  }
                })
                .catch((err) => {
                  dialog.close();
                  this.loading = false
                  this.alert = true
                  this.color = "#F44336"
                  this.text = err;
                  this.showAlert('warning')
                });
          })
          .catch(() => {
            this.$refs.hotTable.hotInstance.alter("insert_row_above", index)

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", false);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 15, "readOnly", false);

            this.$refs.hotTable.hotInstance.populateFromArray(index, 0, [rowId]);

            this.$refs.hotTable.hotInstance.setCellMeta(index, 0, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 2, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 3, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 4, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 7, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 8, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 10, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 11, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 13, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 14, "readOnly", true);
            this.$refs.hotTable.hotInstance.setCellMeta(index, 15, "readOnly", true);
          });
    },
    onFilePicked(e) {
      const files = e.target.files;
      this.file = this.$refs.fileInput.files[0];
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
      const input = document.getElementById("upload");
      input.value = "";
    },
    checkIdHeuresSupExist() {
      this.loading = true
      this.dialog = false;

      if (this.isEmpty(this.editedItem.idHS) || (this.editedItem.idHS === null)) {
        this.creer()
      } else {
        apiClient
            .get(
                `${this.$store.getters.user.baseUrl}/account/isidheuressupexist/` + this.editedItem.idHS
            )
            .then(response => {
              let result = response.data;

              if (result.status === 200) {
                this.creer()
              } else {
                this.alert = true
                this.color = "#F44336"
                this.alert = true
                this.text = result.message;
                this.dialog = false;

                this.showAlert('warning')
                this.loading = false
              }
            })
            .catch(() => {
            });
      }
    },
    creer() {
      const dataToSave = {
        userId: this.editedItem.userId,
        startDate: moment(this.editedItem.startDate).format("YYYY-MM-DD HH:mm:ss"),
        endDate: moment(this.editedItem.endDate).format("YYYY-MM-DD HH:mm:ss"),
        reasonAbsence: this.editedItem.reasonAbsence,
        absenceObservations: this.editedItem.absenceObservations,
        idHS: this.editedItem.idHS
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/account/absence/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false

            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message
              this.dialog = false;
              this.initEditedItem();

              this.showAlert('info')
              this.depthDate();

              this.editedItem.idHS = ""
            } else {
              this.alert = true
              this.color = "#F44336"
              this.alert = true
              this.text = res.data.message;
              this.dialog = false;

              this.showAlert('warning')
            }
          })
          .catch(error => {
            this.alert = true
            this.text = error;
            this.dialog = false;
            this.loading = false
            this.color = "#F44336"
            this.showAlert('warning')
          });
    },
    importFileToHandsonTable() {
      let vm = this;
      vm.loading = true
      vm.dialog = false;
      this.file = ""
      let dataTosave = [];
      const fromExcelDate = require("js-excel-date-convert").fromExcelDate;

      for (let i = 0; i < this.excelData.length; i++) {
        let sdate = moment(fromExcelDate(this.excelData[i][1])).format("YYYY-MM-DD HH:mm:ss")
        let edate = moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD HH:mm:ss")

        if ((sdate === "Invalid date") || (edate === "Invalid date")) {
          this.text = "Date & Heure invalide -> Ligne " + (i + 2) +
              ".\nLes dates doivent être au format DATE et les heures au format HEURE (cf modèle)."

          this.showAlert('warning')
          vm.loading = false
          return;
        }
      }

      for (let i = 0; i < this.excelData.length; i++) {
        dataTosave.push({
          userId: this.excelData[i][0],
          startDate: moment(fromExcelDate(this.excelData[i][1])).format("YYYY-MM-DD HH:mm:ss"),
          endDate: moment(fromExcelDate(this.excelData[i][2])).format("YYYY-MM-DD HH:mm:ss"),
          reasonAbsence: this.excelData[i][3],
          absenceObservations: this.excelData[i][4],
          originUser: sessionStorage.getItem("userId")
        });
      }

      apiClient
          .post(
              `${vm.$store.getters.user.baseUrl}/account/absences/` +
              sessionStorage.getItem("userId"),
              dataTosave
          )
          .then(res => {
            vm.loading = false

            if (res.data.status === 200) {
              let dataObj = [];
              let dataError = []
              for (let i = 0; i < res.data.datas.length; i++) {
                if (res.data.datas[i].status === 200) {
                  dataObj.push(res.data.datas[i].datas);
                } else {
                  dataError.push(res.data.datas[i]);
                }
              }

              if (dataObj.length > 0 && dataError.length === 0) {
                vm.color = "#009688"
                vm.text = dataObj.length + " Absence(s) ajoutée(s).";
                vm.file = "";
                this.showAlert('info')
                this.depthDate()
              } else if (dataObj.length === 0 && dataError.length > 0) {
                vm.alert = true
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                this.depthDate()
              } else if (dataObj.length > 0 && dataError.length > 0) {
                vm.color = "#F44336"
                vm.errors = dataError
                vm.file = "";
                vm.alert = true
                this.depthDate()
              }
            }
          })
          .catch(err => {
            vm.loading = false
            vm.alert = true
            vm.text = err;
            vm.color = "#F44336"
            this.showAlert('warning')
          });
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Planning_absences") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Planning_absences.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    onexportModele() { // On Click Excel download button
      this.loading = true;
      var ws = XLSX.utils.json_to_sheet([
        {
          userId: "Matricule",
          startDate: "Date début",
          endDate: "Date fin",
          reasonAbsence: "Raison absence",
          absenceObservations: "Observations"
        },
        {
          userId: "xxx476",
          startDate: "26/07/2030",
          endDate: "29/07/2030",
          reasonAbsence: "Mariage",
          absenceObservations: "traditionnel au village"
        },
      ], {
        header: ["userId", "startDate", "endDate", "reasonAbsence", "absenceObservations"],
        skipHeader: true,
        cellDates: true
      });

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, ws, "Planning_absences") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Planning_absences_modèle.xlsx", {cellDates: true}) // name of the file is "book.xlsx"
      this.loading = false
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      // this tip, convert FileList to array, credit: https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
      ([...droppedFiles]).forEach(f => {
        this.files.push(f);
      });

      let formData = new FormData();
      this.files.forEach((f, x) => {
        formData.append('file' + (x + 1), f);
      });

      if (!this.files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(this.files[0].name.toLowerCase())) {
        this.text = "Le format du fichier est incorrecte.\nMerci de choisir un format xls ou xlsx";
        this.showAlert('warning');
        return false;
      } else if (this.files.length !== 1) {
        this.text = "Nous ne traitons qu'un fichier excel";
        this.showAlert('warning');
        return false;
      }

      this.file = this.files[0];
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary"
          });
          const wsname = workbook.SheetNames[0];
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], {defval: "", skipHidden: true});
          const excellist = [];
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i]);
          }
          this.total = excellist
              .map(item => item.montant)
              .reduce((prev, curr) => prev + curr, 0);
          this.excelData = excellist.map(function (item) {
            return Object.values(item);
          })

          this.fileBtn = false;
        } catch (e) {
          this.text = "Erreur de lecture du fichier !";
          this.showAlert('warning')
          return false;
        }
      }
      fileReader.readAsBinaryString(this.file);
      const input = document.getElementById("upload");
      input.value = "";
    },
    removeFile(file) {
      this.loading = false
      this.fileBtn = true
      this.drag_over = false
      this.file = ""
      this.files = this.files.filter(f => {
        return f !== file;
      });
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.dg-btn--ok {
  border-color: green;
}

.dg-btn-loader .dg-circle {
  background-color: green;
}

.colHS {
  text-align: center;
  background-color: #FFE0B2 !important;
  font-weight: bold !important;
  font-style: normal !important;
}

.v-btnInfoHS {
  margin-top: 10px;
}
</style>

